<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-group row">
      <div class="col-md-12">
        <yt-input
          [Type]="'text'"
          formControlName="Naziv"
          [MaxLength]="100"
          [Label]="'RADNOMESTO.NAZIV.SINGULAR'"
          [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}">
        </yt-input>
        <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
          <span *ngFor="let validation of errorMessages.Naziv">
            <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <yt-input 
        [Type]="'text'" 
        formControlName="Sifra" 
        [Label]="'RADNOMESTO.SIFRA.SINGULAR'">
        </yt-input>      
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist 
        [ModelName]="'radnomesto'" 
        [GetName]="'getRoot'" 
        [ModelProperty]="'Naziv'" 
        [OrderBy]="'Naziv'"
        [Disabled]='true'
        formControlName="TataID" 
        [Label]="'RADNOMESTO.TATA.SINGULAR'" 
        [Type]="'treeview'">
        </yt-dropdown-picklist>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist 
        [ModelName]="'sprema'" 
        [GetName]="'get'" 
        [ModelProperty]="'Naziv'" 
        [OrderBy]="'Naziv'"
        [Disabled]='true' 
        formControlName="ID" 
        [Label]="'RADNOMESTO.SPREMA.SINGULAR'">
        </yt-dropdown-picklist>
      </div>
    </div>
    <yt-radno-mesto-poslovi-stavka-update-container
      #baseInlineContainer
      [DetailModelData]="modelData.MainList.DetailList[0]"
      [ParentPropertyName]="'RadnoMestoID'"
      [ParentPropertyValue]="Item.ID"
      [Parameters]="TransferParameters"  
>
    </yt-radno-mesto-poslovi-stavka-update-container>
  </form>
</div>
